import { Button, Input, message } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { trackButtonClick } from '../../analytics/mixpanel';
import ellipse from '../../assets/docchat/ellipse.svg';
import DashboardLoader from '../../CommonComponents/dashboard-docchat/DashboardLoader';
import InlineStyled from '../../CommonComponents/InlineStyled/InlineStyled';
import InputUpload2 from '../../CommonComponents/InputUpload/InputUpload2';
import { ERROR } from '../../Constants/commonConstants';
import { contextComparison, getSavedComparisons } from '../../Redux/FileCompare/fileCompareActions';
import { loginStateSelector } from '../../Redux/login/loginReducer';
import { getAxiosErrorMessage } from '../../utils/functions';

function FilePicker() {
  const dispatch = useDispatch();
  const compareData = useSelector((state) => state.compareData);
  const navigate = useNavigate();
  const [fileStatus, setFileStatus] = useState(false);
  const [uploadData, setUploadData] = useState([]);
  // const [viewTour, setViewTour] = useState(false);
  const { userData, docCompareQuota } = useSelector(loginStateSelector);
  const [isLoading, setIsLoading] = useState(false);
  const [comparisonTitle, setComparisonTitle] = useState(null);

  const sendData = async (filesData) => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      if (comparisonTitle?.trim()) {
        formData.append('title', comparisonTitle);
      }
      // formData.append('files', filesData);
      filesData.forEach((file) => {
        formData.append('files', file);
      });
      // documentsFormData.append('modified_document', uploadData.modifiedFile);
      const response = await contextComparison(formData);
      if (response.statusText === 'Created' && response.data?.id) {
        dispatch(getSavedComparisons());
        navigate(`/viewer?uuid=${response.data.id}&type=SAVED`);
      }
    } catch (error) {
      message.error(getAxiosErrorMessage(error));
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <DashboardLoader />;
  }

  return (
    <InlineStyled
      className='file-picker-doccompare'
      style={{
        backgroundImage: `url("${ellipse}")`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50%',
      }}
    >
      <section className='upload-section text-center'>
        <h1 className='text-gradient' style={{ fontSize: '24px', wordBreak: 'break-all' }}>
          {`Hello, ${userData?.name}`}
        </h1>
        <InlineStyled className='mb-24' style={{ color: 'var(--grey-9)', marginTop: '12px' }}>
          Review smarter: Mike DocCompare contextually compares contracts to highlight critical{' '}
          <br /> differences and drive accuracy
        </InlineStyled>
        <div className='upload-section-inner' id='dashboard-tour-step-1'>
          <div className={`upload-docchat ${fileStatus && uploadData?.length > 0 ? 'bg' : ''}`}>
            <div className={docCompareQuota > 0 ? 'upload-inner' : 'upload-inner exhaust'}>
              <InputUpload2
                fileStatus={fileStatus}
                setFileStatus={setFileStatus}
                uploadData={uploadData}
                setUploadData={setUploadData}
                quota={docCompareQuota}
              />
            </div>
          </div>
          {fileStatus && uploadData?.length > 1 && (
            <>
              <Input
                value={comparisonTitle}
                className='mb-24'
                placeholder='Comparison Title'
                style={{ height: '52px', borderRadius: '16px' }}
                onChange={(e) => setComparisonTitle(e.target.value)}
              />

              <Button
                loading={isLoading}
                type='primary'
                onClick={() => {
                  trackButtonClick({ type: 'Compare Documents' });
                  sendData(uploadData);
                }}
                className='btn-l'
              >
                Start Comparing
              </Button>
            </>
          )}
          {compareData.compareStatus === ERROR && compareData.statusText && (
            <div className='fs-14 mt-16 color-danger text-center'>{compareData.statusText}</div>
          )}
        </div>
      </section>
    </InlineStyled>
  );
}

export default FilePicker;
